import React from "react";
import { Stack } from "@carbon/react";
import Card from '../../../components/Layouts/Card';
import Typography from "../../../components/Basics/Typography";
import { Map } from "@carbon/icons-react";
import { Iframe, AppContainer, MapContainer } from "./MonitoringMap.styles";
import { Div } from "../../../components/Basics/Div.styles";
import MapWrapper from "../../../components/MapWrapper/MapWrapper";

const TextWithIcon = ({ imageSrc, text }) => {
  return (
    <Div display="flex" flexDirection="column" alignItems="center" gap="4px">
      <img width="60" height="32" src={imageSrc} alt={text} />
      <Typography className='cds--type-helper-text-01' textAlign="center">{text}</Typography>
    </Div>
  )
}

const MonitoringMapV2 = () => {
  return (
    <Stack gap={3}>
      <Card justifyContent='flex-start' >
        <Map size={18} />
        <Typography className='cds--type-heading-compact-01'>
          MAPA - TIEMPO REAL
        </Typography>
      </Card>
      <Card>
        <AppContainer>
          <MapWrapper />
        </AppContainer>
      </Card>
    </Stack>
  )
}

export default MonitoringMapV2;